import { ROLE_LABEL, type UserRole } from '../../../types/access';
import styles from './RoleBadge.module.scss';
import React from 'react';

interface RoleBadgeProps {
    role: UserRole;
}

const MODIFIER: Record<UserRole, string> = {
    superadmin: styles.superadmin,
    admin: styles.admin,
    user: styles.user,
};

export function RoleBadge({ role }: RoleBadgeProps) {
    return <span className={`${styles.badge} ${MODIFIER[role]}`}>{ROLE_LABEL[role]}</span>;
}
